export class BasicResponse {
    constructor(success: boolean) {
        this.success = success;
    }
    id: string | null | undefined;
    success: boolean;
    errors: Error[] | null | undefined;
    secondaryId!: string | null | undefined;
}

export class Error {
    constructor(code: number, message: string) {
        this.code = code;
        this.message = message;
    }
    code: number;
    message: string;
}
